import { rootState } from '@core-interface'

export const getLocalizationList = (state:rootState) => state?.coreReducer?.localization?.languages;      
export const getLocalizationLanguage = (state:rootState) => state?.coreReducer?.localization?.selected;      